var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"60px","font-size":"20px","font-weight":"600"}},[_vm._v(" 正在登录中,请稍等... ")])}
var staticRenderFns = []

export { render, staticRenderFns }